import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Actions, ofType } from '@ngrx/effects';

import { ISeSideKeyObjectImage } from '../se-side-key-images-models'
import { KeyImage } from '../../../../services/imaging/common';
import { Store } from '@ngrx/store';
import { seReportSaveCompleted, seReportSetIsModified } from '../../../../report/report.actions';

@Component({
    selector: 'se-side-key-images-item',
    templateUrl: './se-side-key-images-item.component.html',
    styleUrls: ['./se-side-key-images-item.component.scss'],
    standalone: false
})
export class SeSideKeyImagesItemComponent implements OnInit, OnChanges {

    @Input() keyImageObject: ISeSideKeyObjectImage;
    @Input() readonly = true;

    @Output() updateStateEvent = new EventEmitter<KeyImage>();
    @Output() deleteImageEvent = new EventEmitter<ISeSideKeyObjectImage>();

    checked: boolean = true;
    showLockIcon: boolean = false;
    showTextArea: boolean = false;
    notesContent: string = '';
    notesTempContent: string = '';
    showEditIcon: boolean = false;
    imageSource: SafeResourceUrl;

    private unsanitizedImg: string;
    private SOPInstanceUID: string;
    private RepositoryKey: string;
    private IdExamination: string;

    constructor(private sanitizer: DomSanitizer,
        private actions$: Actions,
        private store: Store) {
        this.actions$.pipe(ofType(seReportSaveCompleted)).subscribe(() => {
            this.showTextArea = false;
            this.showEditIcon = false;
            this.notesTempContent = !!this.notesContent ? this.notesContent : '';
        });
    }

    ngOnChanges(): void {
        this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.keyImageObject.Image}`);
        this.unsanitizedImg = this.keyImageObject.Image;
        this.SOPInstanceUID = this.keyImageObject.SOPInstanceUID;
        this.RepositoryKey = this.keyImageObject.RepositoryKey;
        this.IdExamination = this.keyImageObject.IdExamination;
        this.notesContent = this.keyImageObject.Caption;
        this.checked = !this.keyImageObject.ExcludedFromReport;
        this.showLockIcon = this.readonly || !this.keyImageObject.IsDeletable;
    }

    ngOnInit(): void {
        this.notesTempContent = !!this.notesContent ? this.notesContent : '';
    }

    //called when clicking the card
    clicked() {
        this.checked = !this.checked;
        this.emitSaveEvent();
    }

    checkEditChanges() {
        if (this.notesTempContent == this.notesContent) {
            this.showEditIcon = false;
        }
        else {
            this.showEditIcon = true;
        }
    }

    //called when clicking on pencil icon
    editNotes() {
        if (this.showTextArea) {
            this.checkEditChanges();
            this.emitSaveEvent();
        }
        this.showTextArea = !this.showTextArea;
    }

    deleteCard() {
        this.emitDeleteEvent();
    }

    emitSaveEvent() {
        let currentObject: KeyImage = {
            SOPInstanceUID: this.SOPInstanceUID,
            RepositoryKey: this.RepositoryKey,
            IdExamination: this.IdExamination,
            Caption: this.notesContent,
            ExcludedFromReport: !this.checked,
            IsDeletable: !this.showLockIcon
        }
        this.updateStateEvent.emit(currentObject);
        this.store.dispatch(seReportSetIsModified({ isModified: this.showEditIcon }));
    }

    emitDeleteEvent() {
        let currentObject: ISeSideKeyObjectImage = {
            Image: this.unsanitizedImg,
            SOPInstanceUID: this.SOPInstanceUID,
            RepositoryKey: this.RepositoryKey,
            IdExamination: this.IdExamination,
            Caption: this.notesContent,
            ExcludedFromReport: !this.checked,
            IsDeletable: !this.showLockIcon
        }
        this.deleteImageEvent.emit(currentObject);
    }
}
